// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__iJYt0","col":"styles_col__2533H","fulfillmentStatus":"styles_fulfillmentStatus__3PTmG","emailCol":"styles_emailCol__4yj-M"};